import { diag, DiagConsoleLogger, DiagLogLevel } from '@opentelemetry/api';
import { BaseOtelService } from '../BaseOtelService/BaseOtelService.mjs';
import { DefaultMeterProvider } from './DefaultMeterProvider.mjs';

class DefaultOtelService extends BaseOtelService {
  /**
   * Bootstraps an Otel exporter which can send Otel metrics to a dedicated Shopify supported collector endpoint.
   */
  constructor({
    throttleLimit = 5000,
    env = 'local',
    serviceName,
    prefixMetric = false,
    metrics = {},
    onRecord,
    meterProvider,
    useXhr = false,
    dev = false
  }) {
    diag.setLogger(new DiagConsoleLogger(), ['production', 'staging'].includes(env) ? DiagLogLevel.ERROR : DiagLogLevel.INFO);
    super({
      serviceName,
      meterProvider: meterProvider !== null && meterProvider !== void 0 ? meterProvider : new DefaultMeterProvider({
        serviceName,
        env,
        throttleLimit,
        useXhr,
        dev
      }),
      prefixMetric,
      metrics,
      onRecord
    });
  }
  shutdown() {
    diag.disable();
    return super.shutdown();
  }
}

export { DefaultOtelService };
